// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"560":"eef152afb1ce01bc","852":"b1e4157fa7acc566","894":"95144845260ab609","943":"4068d8e9a9761e33"}[chunkId] + ".js";
};